export const newsList = [
  {
    id: "n1",
    title: "社区老槐树广场完成改造，新增儿童游乐与健身区",
    summary: "历时两个月的社区广场改造正式完工，新增儿童游乐区、老年健身角与夜间照明，成为居民休闲新去处。",
    category: "社区建设",
    tags: ["社区改造", "公共空间", "便民"],
    author: "邻居编辑部",
    date: "2026-10-08",
    views: 2380,
    cover: "https://readdy.ai/api/search-image?query=Warm%20sunny%20community%20plaza%20with%20green%20trees%20and%20wooden%20benches%2C%20children%20playground%20colorful%20equipment%2C%20soft%20natural%20daylight%2C%20cozy%20residential%20neighborhood%20atmosphere%2C%20bright%20and%20welcoming&width=1200&height=800&seq=news-square-01&orientation=landscape",
    content: [
      "经过两个多月的紧张施工，社区中心的槐树广场终于以崭新的面貌与居民见面。改造后的广场不仅保留了原有的老槐树与树荫步道，还新增了儿童游乐区、老年健身角和夜间照明系统，成为全龄段居民共享的公共空间。",
      "据社区工作人员介绍，本次改造充分听取了居民意见，前后共组织了三场居民议事会。儿童游乐区配备了软胶地面和组合滑梯，健身角则添置了坐蹬训练器、漫步机等十余种器材，满足不同年龄段的锻炼需求。",
      "夜幕降临，新安装的暖色景观灯亮起，广场上散步、跳广场舞、带孩子玩耍的居民络绎不绝。住在三号楼的王阿姨高兴地说：“以前晚上黑灯瞎火的，现在亮堂多了，下楼遛弯心里也踏实。”",
      "社区负责人表示，广场后续还将增设便民饮水点与共享雨伞架，并组织志愿者定期维护，让这份公共福利长久地惠及每一位邻居。",
    ],
  },
  {
    id: "n2",
    title: "本周六社区旧物交换市集开市，欢迎带上闲置好物",
    summary: "以物易物、以旧会友，本周六上午社区广场举办旧物交换市集，已有四十余户家庭报名参加。",
    category: "社区活动",
    tags: ["市集", "环保", "邻里互动"],
    author: "社区活动组",
    date: "2026-10-06",
    views: 1856,
    cover: "https://readdy.ai/api/search-image?query=Cozy%20outdoor%20community%20flea%20market%20with%20wooden%20stalls%2C%20second%20hand%20books%20and%20plants%20on%20tables%2C%20people%20chatting%20friendly%2C%20warm%20afternoon%20sunlight%2C%20soft%20green%20and%20orange%20tones&width=1200&height=800&seq=news-market-02&orientation=landscape",
    content: [
      "闲置的图书、玩具、小家电、绿植……与其堆在角落积灰，不如让它们找到新的主人。本周六上午九点，社区旧物交换市集将在槐树广场准时开市。",
      "活动采取“以物易物”的方式，居民可携带家中闲置且状况良好的物品前来交换，也欢迎纯粹来逛市集、认识邻居的朋友。目前已有四十余户家庭报名，交换品类涵盖家居、童书、园艺工具等多个门类。",
      "主办方提醒，请勿携带食品、药品及存在安全隐患的物品。现场设有志愿者服务台，可协助登记与引导。市集将持续到中午十二点，遇到雨天顺延至下周六。",
      "“旧物交换不只是节约，更是让邻里之间多一次打招呼的机会。”活动组织者小李笑着说。",
    ],
  },
  {
    id: "n3",
    title: "社区食堂推出秋季暖心菜单，环卫工人可享免费早餐",
    summary: "社区长者食堂上新秋季菜谱，并面向环卫工人、快递员提供每日限量免费早餐，传递邻里温情。",
    category: "便民服务",
    tags: ["社区食堂", "公益", "长者关怀"],
    author: "邻居编辑部",
    date: "2026-10-04",
    views: 3210,
    cover: "https://readdy.ai/api/search-image?query=Warm%20community%20canteen%20interior%20with%20wooden%20tables%2C%20bowls%20of%20hot%20soup%20and%20rice%20dishes%2C%20soft%20yellow%20lighting%2C%20cozy%20homely%20atmosphere%2C%20gentle%20orange%20tones&width=1200&height=800&seq=news-canteen-03&orientation=landscape",
    content: [
      "入秋以来，社区长者食堂适时推出了暖心菜单，加入羊肉萝卜汤、山药排骨、南瓜小米粥等温补菜品，受到居民欢迎。65岁以上长者可凭证件享受优惠价。",
      "更让人心头一暖的是，食堂从本月起每天限量提供20份免费早餐，面向在社区内作业的环卫工人和快递员。“他们起得最早、最辛苦，一碗热粥是我们的一点心意。”食堂负责人说。",
      "食堂每日供应早、中两餐，营业时间为早上六点半到下午一点。有需要的居民可现场就餐，也支持打包。",
      "不少居民表示，社区食堂不仅解决了做饭难题，更成了大家聊天、增进感情的地方。",
    ],
  },
  {
    id: "n4",
    title: "社区秋季健康义诊进小区，免费测血压血糖",
    summary: "社区卫生服务中心联合志愿者团队开展秋季义诊，为居民提供免费血压、血糖检测及健康咨询。",
    category: "健康生活",
    tags: ["义诊", "健康", "公益"],
    author: "社区卫生院",
    date: "2026-10-02",
    views: 1470,
    cover: "https://readdy.ai/api/search-image?query=Community%20health%20clinic%20outdoor%20tent%20with%20medical%20staff%20checking%20blood%20pressure%20for%20elderly%2C%20clean%20bright%20setting%2C%20green%20and%20white%20tones%2C%20caring%20atmosphere&width=1200&height=800&seq=news-health-04&orientation=landscape",
    content: [
      "为提升居民健康意识，社区卫生服务中心将于本周末在各小区轮流开展秋季义诊活动。现场提供免费血压、血糖检测，以及中医问诊、用药指导等服务。",
      "义诊同时，医护人员还将为居民建立健康档案，提醒慢性病患者按时复查。针对行动不便的老人，志愿者可提供上门预约登记。",
      "活动时间为周六、周日上午八点到十一点，地点设在各小区中心广场。请参与检测的居民尽量空腹前往，以便获得更准确的血糖数据。",
      "社区提醒，日常注意均衡饮食与适度运动，如遇身体不适请及时就医。",
    ],
  },
  {
    id: "n5",
    title: "社区图书角焕新，居民捐书超八百册",
    summary: "在居民热心捐赠下，社区图书角藏书突破八百册，新增亲子阅读区与静音自习位，全天开放。",
    category: "社区建设",
    tags: ["图书角", "阅读", "亲子"],
    author: "邻居编辑部",
    date: "2026-09-28",
    views: 1120,
    cover: "https://readdy.ai/api/search-image?query=Cozy%20community%20reading%20corner%20with%20wooden%20bookshelves%20full%20of%20books%2C%20soft%20warm%20lamp%20light%2C%20colorful%20cushions%20and%20reading%20nook%2C%20inviting%20homely%20atmosphere&width=1200&height=800&seq=news-library-05&orientation=landscape",
    content: [
      "经过一个月的募集与整理，社区图书角完成焕新升级。居民们踊跃捐出闲置书籍，累计超过八百册，涵盖文学、历史、少儿绘本、生活百科等多个类别。",
      "新图书角划分出亲子阅读区与静音自习位，配备了舒适的坐垫与台灯，工作日与周末全天开放。借阅采取自助登记，一次可借两本，两周内归还。",
      "不少家长带着孩子前来，把这里当成了周末的“小书房”。“书不用买，大家换着看，孩子也更爱读书了。”居民张先生说。",
      "图书角长期接受捐书，欢迎邻居们继续把好书分享出来。",
    ],
  },
  {
    id: "n6",
    title: "社区志愿者招募开启，一起参与绿化与巡河",
    summary: "社区志愿服务队开启新一轮招募，面向居民招募绿化养护、巡河护河及助老帮扶志愿者。",
    category: "社区活动",
    tags: ["志愿者", "环保", "招募"],
    author: "社区志愿队",
    date: "2026-09-24",
    views: 980,
    cover: "https://readdy.ai/api/search-image?query=Group%20of%20friendly%20volunteers%20planting%20green%20seedlings%20in%20community%20garden%2C%20wearing%20green%20vests%2C%20sunny%20day%2C%20warm%20collaborative%20atmosphere%2C%20fresh%20green%20tones&width=1200&height=800&seq=news-volunteer-06&orientation=landscape",
    content: [
      "社区志愿服务队新一轮招募正式启动。本次计划招募绿化养护、巡河护河、助老帮扶三类志愿者，服务时间灵活，居民可按自身情况选择。",
      "绿化养护志愿者主要负责社区花坛的浇灌与除草；巡河护河志愿者每周沿河道巡查一次，清理垃圾并记录情况；助老帮扶志愿者则为独居老人提供陪伴与代购服务。",
      "社区将为志愿者提供统一马甲、工具与保险，并定期组织培训与交流。累计服务时长可在年底评选“最美邻居”。",
      "报名可到社区服务中心登记，或在“邻居”平台发布信息联络志愿队。期待更多邻居加入，让社区更有温度。",
    ],
  },
];

export const newsTags = ["全部", "社区建设", "社区活动", "便民服务", "健康生活"];